import { root } from './summary';

export const summary = {
  ...root,
};
